import  {useEffect, useState} from "react"
import './fontCss/LogoChannel.css'
import LiveShowDetails from "./liveShowDetails";
import {getLogoURL} from "../globalMethods/utils";

const LiveShowItem = (props) => {

    const [channel, setChannel] = useState( props?.channel)

    useEffect(()=>{
        const getChannelFromChannels = ()=> {

            let foundChannel = Object.assign({}, channel)
            const imageResolution = foundChannel.LogoUrl
            foundChannel.LogoUrl = getLogoURL(imageResolution)
            setChannel(foundChannel)

        }
        getChannelFromChannels()
    }, [channel])

    return <div style={{marginLeft:8, marginRight:8}}>
            <LiveShowDetails showEvents ={props?.showEvents} EpgId = {channel?.EpgId} LogoUrl ={channel?.LogoUrl} Name={channel?.Name}></LiveShowDetails>
       </div>
}

export default LiveShowItem